import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import classNames from "classnames";

export const OfferEmptyState = observer(function (props: {
	icon?: string;
	subtitle: string;
	description: string;
	callToActionUrl: string;
	callToActionLabel: string;
	isOnHomepage?: boolean;
}) {
	const t = useTranslation().t;

	return (
		<div
			className={classNames("card--empty", {
				"card--empty--borderless card--empty--radial u-mar--bottom--reset":
					props.isOnHomepage,
			})}
		>
			<div className="card--empty__content">
				<i
					className={
						"card--empty__icon u-icon u-icon--huge u-icon--empty u-icon--empty--" +
						(props.icon ? props.icon : "sports")
					}
				/>
				<div className="card--empty__title">{t(props.subtitle)}</div>
				<div className="card--empty__message">
					{t(props.description)}
				</div>
				<Link
					to={props.callToActionUrl}
					className="card--empty__btn btn btn--sml btn--primary--inverted btn--icon btn--animate-forward"
				>
					{t(props.callToActionLabel)}
					<i className="u-icon u-icon--tny u-icon--arrow-right" />
				</Link>
			</div>
		</div>
	);
});
